module.exports = __webpack_public_path__ + "static/p11_kikiriki-2ac5d3bde445dfec51891185c9d16e04.png";